export const createBankAgreementFormRepository = (appFetch) => {
    return {
        esiaInfo(options = {}) {
            return appFetch.get('/cabinet/bank-agreement/api/esia-info', options);
        },
        send(body, options = {}) {
            return appFetch.post('/cabinet/bank-agreement/api/send', body, options);
        },
    };
};
